import { auctionTypeOptions } from 'components/ListVehicles/components/CreateVehicleDialog/AuctionField';
import { Vehicle } from 'types/vehicle';

const createInitialOption = (vehicle: Vehicle, key: keyof Vehicle) => {
  const value = vehicle[key];
  if (!value) return null;
  if (vehicle.upload_type === 'manual') {
    return value;
  }
  return { value, label: value };
};

export const serializeUploadInitialValues = (vehicle?: Vehicle) => {
  if (!vehicle) return {};
  return {
    id: vehicle.id,
    trim: createInitialOption(vehicle, 'trim'),
    transmission: createInitialOption(vehicle, 'transmission'),
    engine: createInitialOption(vehicle, 'engine'),
    drive_train: createInitialOption(vehicle, 'drive_train'),
    ext_color: createInitialOption(vehicle, 'ext_color'),
    year: vehicle.year,
    make: vehicle.make,
    model: vehicle.model,
    options: vehicle.options,
    starting_bid: vehicle.starting_bid,
    reserve_price: vehicle.reserve_price,
    mileage: vehicle.mileage,
    bluebook_mileage: vehicle.bluebook_mileage,
    bluebook_value: vehicle.bluebook_value,
    bluebook_mileage_adjustment: vehicle.bluebook_mileage_adjustment,
    upload_type: vehicle.upload_type,
    status: vehicle.status
  };
};

export const getAuctionTypeInitialValue = (vehicle?: Vehicle) => {
  if (!vehicle || !vehicle.auction_type) return auctionTypeOptions[0];
  return auctionTypeOptions.find(opt => opt.value === vehicle.auction_type) || auctionTypeOptions[0];
};
